module.exports = __webpack_public_path__ + "img/group_add_opsz20.035c7bff.svg";